import { jsx as o } from "react/jsx-runtime";
import { twMerge as e } from "tailwind-merge";
import { BaseSwitcher as m } from "./base-switcher.mjs";
const h = ({
  selected: r,
  onChange: t,
  switcherClassName: a,
  disabled: n,
  ...i
}) => {
  const s = e(
    "main-transition-colors focus-ring relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
    r && !n ? "bg-brand-primary" : "bg-fill-primary",
    a
  ), l = /* @__PURE__ */ o(
    "span",
    {
      "aria-hidden": "true",
      className: e(
        "bg-background-secondary pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-lg ring-0 transition-transform duration-200 ease-linear",
        r ? "translate-x-5" : "translate-x-0"
      )
    }
  );
  return /* @__PURE__ */ o(
    m,
    {
      switcherElement: l,
      selected: r,
      disabled: n,
      onChange: t,
      switcherClassName: s,
      ...i
    }
  );
};
export {
  h as CheckBoxSwitcher
};
